import ArticleView from "../utils/ArticleView";

const ArticleEmergency = () => {
  return ArticleView("emergency");
};
  
export default ArticleEmergency;